import { Routes, Route } from 'react-router-dom';

import { ErrorBoundary } from 'react-error-boundary';

import { UserContext, useUserData } from './Pages/UserContext';

import { MainPage } from './Pages/MainPage/MainPage';
import { MapPage } from './Pages/MapPage/MapPage';
import { NotFoundPage } from './Pages/NotFoundPage/NotFoundPage';
import { ProfilePage } from './Pages/ProfilePage/ProfilePage';
import { WelcomePage } from './Pages/WelcomePage/WelcomePage';
import { CartPage } from './Pages/CartPage/CartPage';
import { Header } from './Components/Header';
import { Footer } from './Components/Footer';
import { ErrorPageComponent } from './Components/ErrorPageComponent';
import { WishListPage } from './Pages/WishListPage/WIshListPage';

import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import './App.css';

function App() {
  const { Provider } = UserContext;
  const data = useUserData();
  return (
    <ErrorBoundary FallbackComponent={ErrorPageComponent}>
      <Provider value={data}>
        <div className="app flex flex-col justify-between">
          <Header />
          <Routes>
            <Route path="/catalog" element={<MainPage />} />
            <Route path="/profile" element={<ProfilePage />} />
            <Route path="/map" element={<MapPage />} />
            <Route path="/cart" element={<CartPage />} />
            <Route path="/wishlist" element={<WishListPage />} />
            <Route path="/" element={<WelcomePage />} />
            <Route path="*" element={<NotFoundPage />} />
          </Routes>
          <Footer />
        </div>
        <ToastContainer
          position="top-center"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="colored"
        />
      </Provider>
    </ErrorBoundary>
  );
}

export default App;
